
import { Heart, Shield, TrendingUp, Zap, Target, Star } from 'lucide-react';
import AnimatedCounter from '@/components/AnimatedCounter';

const BenefitsSection = () => {
  const benefits = [
    { icon: Heart, text: "Scientifically proven PACT method" },
    { icon: Shield, text: "Minimalist, distraction-free interface" },
    { icon: TrendingUp, text: "Streak tracking for motivation" },
    { icon: Zap, text: "Strategic skip system included" },
    { icon: Target, text: "Visual progress tracking" },
    { icon: Star, text: "Coming very soon" }
  ];

  return (
    <section className="container max-w-6xl mx-auto px-4 py-20">
      <div className="grid md:grid-cols-2 gap-16 items-center">
        <div>
          <h3 className="text-3xl font-bold text-deep-blue mb-8">
            Everything You Need to Start
          </h3>
          <div className="space-y-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center gap-4 group">
                <div className="w-10 h-10 bg-vibrant-orange/10 text-vibrant-orange rounded-full flex items-center justify-center group-hover:bg-vibrant-orange group-hover:text-white transition-all duration-300">
                  <benefit.icon className="w-5 h-5" />
                </div>
                <span className="text-deep-blue/80 text-lg">{benefit.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-gradient-to-br from-soft-blue/30 to-white rounded-3xl p-10 shadow-lg border border-soft-blue/50">
          <div className="text-center mb-8">
            <div className="text-5xl font-bold text-vibrant-orange mb-3">
              <AnimatedCounter target={30} suffix=" Days" />
            </div>
            <div className="text-deep-blue/70 text-lg">Average to build a habit</div>
          </div>
          <div className="w-full bg-soft-blue rounded-full h-4 mb-6">
            <div className="bg-gradient-to-r from-vibrant-orange to-vibrant-orange/80 h-4 rounded-full w-3/4 transition-all duration-1000"></div>
          </div>
          <p className="text-sm text-deep-blue/60 text-center leading-relaxed">
            Start with curiosity, not commitment. Build the practice first, then expand naturally.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
